<template>
  <div class="flex items-center justify-between p-3">
    <div class="w-12 h-12">
      <div 
        @click="() => { window.location.href = 'https://courdescomptes.bj' }"
        class="cursor-pointer"
      >
        <Image v-bind="currentLogoProps" />
      </div>
    </div>
    <HamburgerBtn 
      @click="handleClose"
      :is-open="isMenuOpen"
      class="laptop:hidden"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Image from '@/components/atoms/image/Image.vue'
import HamburgerBtn from '@/components/atoms/button/HamburgerBtn.vue'
import { MOBILE_LOGO_PROPS } from '../constants/mobileNavigation'

interface Props {
  logoProps?: any
  isMenuOpen: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()

const currentLogoProps = computed(() => props.logoProps || MOBILE_LOGO_PROPS)

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

